import httpClient from "./httpClient";

const prefix = "/rols";

export async function listAllRoles() {
  return (await httpClient.get(prefix + "/list-all")).data;
}

export async function listRoles(params = {}) {
  return (await httpClient.get(prefix, { params })).data;
}

export async function getRoleById(id) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function createRole(body) {
  return (await httpClient.post(prefix, body)).data;
}

export async function updateRole(id, body) {
  return (await httpClient.patch(`${prefix}/${id}`, body)).data;
}

export async function updateRoleStatus(id, isActive) {
  return (await httpClient.patch(`${prefix}/${id}/status`, { isActive })).data;
}

export async function deleteRole(id) {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

export function roleApiError(error) {
  const message = error?.response?.data?.message;
  if (Array.isArray(message)) return message.join(". ");
  return message || error?.message || "Ocurrió un error";
}
